module.exports = __webpack_public_path__ + "img/logo-dark.a2bbec72.svg";